import styled from "styled-components";
// Stacked (narrow-container) overrides are injected at runtime, NOT here: this
// project's styled-components (v5 / stylis 3.5) does not support the @container
// at-rule and strips the nested selectors, producing invalid CSS. They are
// also NOT a plain `import "./x.css"` -- the production esbuild micro bundle
// emits that into a separate css file the host never links, so the rule
// vanished on staging while Vite dev injected it. injectConditionsResponsiveStyles
// ships the rule as a JS string and adds it via a <style> tag (bundler-agnostic),
// keyed on the stable classes added via .attrs. See conditions-responsive-styles.ts
// and EditAutomationPanelStyles (the container).
import { injectConditionsResponsiveStyles } from "./conditions-responsive-styles";

injectConditionsResponsiveStyles();

export const Root = styled.div<{ smallMargin?: boolean; $hasError?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;

  width: 100%;
  /* When a field-missing error follows, the row keeps only a small gap to the
     message (ErrorRow owns the spacing to the next condition). */
  margin-bottom: ${({ smallMargin, $hasError }) =>
    $hasError === true ? "4px" : smallMargin === true ? "6px" : "18px"};

  .trash-bin-icon {
    margin-left: 10px;
  }

  .add-interval-button {
    display: none;
  }
`;

export const Separator = styled.div`
  margin-right: 10px;
`;

export const Section = styled.div.attrs({ className: "cl-condition-section" })`
  display: block;
  width: 100%;
  max-width: 100%;
`;

/* Field-missing validation error ("Please remove invalid values"). Rendered as
   its own in-flow row BELOW the condition controls (not inside the flex
   Section), so it never grows the controls' height -- the trash stays aligned
   to the input row -- while still adding real vertical space so the message
   doesn't crowd the next condition. Padded left to sit under the field input;
   the stacked variant nudges it 7px more (see conditions-responsive.css). */
export const ErrorRow = styled.div.attrs({ className: "cl-condition-error" })`
  padding-left: 80px;
  margin-bottom: 18px;
`;

export const Selector = styled.div.attrs({
  className: "cl-condition-selector",
})`
  display: inline-block;
  margin-left: 10px;
  width: calc(25% - 10px);
  vertical-align: top;
`;

export const Argument = styled.div.attrs({
  className: "cl-condition-argument",
})`
  display: inline-block;
  margin-left: 10px;
  width: calc(50% - 10px);
  vertical-align: top;

  .input-picker-group__plus-button,
  .pill-picker-editor__plus-button {
    top: 9px;
    right: 9px;

    display: inline-flex;
  }
`;

export const ArgTitle = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  height: 36px;
`;

export const IconWrapper = styled.div.attrs({
  className: "cl-condition-trash",
})`
  height: 36px;
  display: flex;
  align-items: center;
`;

export const ConditionTriggerWrapper = styled.div`
  min-width: 80px;
  max-width: 80px;
`;
